import { getTeam as getTeamService, addToTeam as addToTeamService } from "services/team.service";

export function useGetTeam() {
    const getTeam = async () => {
        try{
            const data = await getTeamService();
            return data;
        } catch (error) {
            console.error("Erro ao buscar times:", error);
            return [];
        }
    }
    return { getTeam };
}

export function useAddTeam() {
    const addToTeam = async (id: string, player: string) => {
        try {
            const data = await addToTeamService(id, player);
            return data;
        } catch (error) {
            console.error("Erro ao adicionar membro ao time:", error);
            return null;
        }
    }
    return { addToTeam };
}